import React from 'react';
import { ReactComponent as SearchIcon } from '../../icons/chat_search.svg';
import s from './SearchInput.module.css';

export function SearchInput({
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder = 'Поиск...',
  ariaLabel = 'Поиск',
  inputRef,
  className = '',
}) {
  const innerRef = React.useRef(null);
  const ref = inputRef ?? innerRef;

  const handleChange = (e) => {
    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  const handleClear = () => {
    if (typeof onChange === 'function') {
      const e = { target: { value: '' } };
      onChange(e);
    }
    try {
      ref.current?.focus();
    } catch {}
  };

  return (
    <div className={`${s.box} ${className}`.trim()}>
      <span className={s.icon} aria-hidden="true">
        <SearchIcon />
      </span>
      <input
        ref={ref}
        type="text"
        className={`${s.input} ${value ? s.inputWithClear : ''}`}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-label={ariaLabel}
      />
      {value && (
        <button
          type="button"
          className={s.clearBtn}
          aria-label={`Очистить: ${ariaLabel}`}
          onClick={handleClear}
        >
          <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M21 1L11 11M11 11L1 21M11 11L1 1M11 11L21 21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
}
